<template>
    <div class="container">
        <template v-if="permitStateRep">
            <!-- state-rep referral portal section -->
            <div class="row mt-3">
                <div class="col-12">
                    <div class="card bg-white">
                        <div v-if="user" class="card-body">
                            <dl class="row mb-0">
                                <dt class="col-12">
                                    <h3 class="text-dark-green nav-settings-head">State-Rep Portal</h3>
                                </dt>
                                <dt class="col-lg-10 col-md-9 col-sm-8 col-12">
                                    <p v-if="userRoles">I'm a: {{userRoles}}</p>
                                </dt>
                                <dd class="col-lg-2 col-md-3 col-sm-4 col-12">
                                    <div class="row">
                                        <div class="col-12">
                                            <button v-if="showSearchBox" @click.prevent="hideNewMarketer" class="btn btn-outline-danger btn-sm form-control">
                                                Close
                                            </button>
                                            <button v-else @click.prevent="showNewMarketer" class="btn btn-light-green btn-sm form-control">
                                                New Marketer
                                            </button>
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl v-if="showSearchBox" class="row">
                                <form class="col-12" @submit.prevent="searchHandleFxn">
                                    <div class="input-group">
                                        <input type="text" v-model="userHandleBox" @keyup="searchHandleFxn" placeholder="Search users name or handle" class="form-control no-lines">
                                        <div class="input-group-append">
                                            <div @click.prevent="searchHandleFxn" class="input-group-text bg-light text-dark-green font-weight-bold clickable">
                                                <i class="fas fa-search mr-1"></i> <span class="hide-on-mobile">Search</span>
                                            </div>
                                        </div>
                                    </div>    
                                </form>
                            </dl>
                            <!-- display search results -->
                            <div v-if="resultsFound" class="row">
                                <div class="col-12">
                                    <p v-for="(result, i) in resultsFound" :key="i">
                                        <router-link :to="{ name: 'portal-lookup', params: { userId: result.userId} }">
                                            <i v-if="result.type == 'handle'" class="fas fa-at text-dark-green"></i> 
                                            <i v-else class="fas fa-user"></i> 
                                            {{ result.value | capitalize }}
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- state-rep list of marketers -->
            <div class="row my-3">
                <div class="col-12">
                    <div class="card bg-white">
                        <div class="card-body">
                            <form v-if="user">
                                <dl class="row mb-0">
                                    <dt class="col-12">
                                        <div class="float-left">
                                            <h3 @click.prevent="showMarketers = !showMarketers" class="text-dark-green nav-settings-head clickable">
                                                My Marketers
                                                <span v-if="myMarketers" class="badge badge-light">{{myMarketers.length}}</span>
                                            </h3>
                                        </div>
                                        <div class="float-right">
                                            <button @click.prevent="showMarketers = !showMarketers" class="btn btn-light-green btn-sm">
                                                <i v-if="showMarketers" class="fas fa-arrows-alt-v"></i>
                                                <i v-else class="fas fa-expand-alt"></i>
                                            </button>
                                        </div>
                                    </dt>
                                </dl>
                                <div v-if="showMarketers" class="table-responsive mt-1">
                                    <table class="table table-striped">
                                        <thead class="bg-silver">
                                            <tr>
                                                <th scope="col">S/N</th>
                                                <th scope="col">Marketer</th>
                                                <th scope="col">Referred</th>
                                                <th scope="col">Active</th>
                                                <th scope="col">Added</th>
                                                <th scope="col" class="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="myMarketers">
                                            <tr v-for="(marketer, i) in myMarketers" :key="i">
                                                <td>{{i + 1}}.</td>
                                                <td class="text-capitalize">
                                                    <router-link :to="{ name: 'marketers-table', params: { userId: marketer._id } }"> 
                                                        {{marketer.name}} 
                                                        <span class="text-dark-green text-lowercase">@{{marketer.userHandle}}</span>
                                                    </router-link> 
                                                </td>
                                                <td>{{marketer.totalReferred}}</td>
                                                <td>
                                                    <span v-if="marketer.active" class="text-dark-green">Yes</span>
                                                    <span v-else class="text-danger">No</span>
                                                </td>
                                                <td>{{marketer.joined | moment("MMM D 'YY")}}</td>
                                                <td class="text-center">
                                                    <router-link :to="{ name: 'marketers-table', params: { userId: marketer._id } }" class="btn btn-light-green btn-sm">
                                                        <i class="fas fa-table"></i>
                                                    </router-link>
                                                    <router-link :to="{ name: 'lookup-handle', params: { handle: marketer.userHandle } }" class="btn btn-outline-dark btn-sm mx-1">
                                                        <i class="fas fa-user"></i>
                                                    </router-link>
                                                    <button @click.prevent="removeMarketerFxn(marketer)" class="btn btn-outline-danger btn-sm">
                                                        <i class="fas fa-trash-alt"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row mt-3">
                <div class="col-12 text-center text-danger">
                    <h3>Insufficient Permissons!!!</h3>
                    <p>You're unauthorized to access Reps page, contact support to request access.</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { copyTextFxn, capitalizeWord } from '@/store/dry'
import LayoutUser from '@/layouts/User.vue'
export default {
    name: "StateReps",
    data() {
        return {
            userHandle: '',
            resultsFound: [],
            suggestions: false,
            copied: false,
            showSearchBox: false,
            showMarketers: false,
            userHandleBox: '',
            msg: '',
            color: ''
        }
    },
    methods: {
        ...mapActions(['portalSearchUsers', 'fetchMarketers', 'removeMarketer']),
        runFetchMarketers() {
            let userObj = {
                userId: this.user._id // stateRepId
            }
            this.fetchMarketers(userObj).then(() => {}).catch((e) => {})
        },
        showNewMarketer() {
            this.userHandleBox = ''
            this.resultsFound = []
            this.showSearchBox = true
        },
        hideNewMarketer() {
            this.userHandleBox = ''
            this.resultsFound = []
            this.showSearchBox = false
        },
        searchHandleFxn(){
            this.userHandleBox = this.userHandleBox.trim()
            if(this.userHandleBox.length < 2){ this.resultsFound = []; return }
            this.userHandleBox = this.userHandleBox.split(" ").join("")
            let userObj = {
                handleSearch: this.removeAtSign(this.userHandleBox)
            }
            this.portalSearchUsers(userObj)
            .then((data) => {
                if(!data.error){
                    this.resultsFound = data.result
                }
                this.msg = data.msg
            }).catch((e) => {
                this.msg = "This handle has no account with us!"
            })
        },
        removeAtSign(val) {
            // ensure it doesn't begin with @ sign
            val = val.toLowerCase()
            let atSymbol = val.slice(0, 1) 
            if(atSymbol !== "@"){ return val }
            else { return val.slice(1, val.length) }
        },
        copyURL() {
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 1000)
            copyTextFxn(this.$refs.myRefLink.innerText)
        },
        removeMarketerFxn(theMarketerObj) {
            this.color = "danger"
            let marketerObj = {
                stateRepId: this.user._id,
                marketerId: theMarketerObj._id
            }
            // vuejs-dialog usage for pop up confirmations
            // https://github.com/Godofbrowser/vuejs-dialog
            let message = `<center>This will remove ${capitalizeWord(theMarketerObj.name)} from your marketers! Do you want to proceed ?</center>`;
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                this.removeMarketer(marketerObj)
                .then((data) => {
                    if(!data.error){
                        this.color = "success"
                        // re-fetch the list of marketers
                        this.runFetchMarketers()
                    }
                    this.msg = data.msg
                })
                .catch((e) => {})
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'setMarketers']),
        myMarketers() {
            if(this.setMarketers && this.setMarketers.length) {
                return this.setMarketers
            }
            return false
        },
        userRoles() {
            if(this.user && this.user.roles){
                return this.user.roles.join(", ")
            }
            return false
        },
        permitStateRep() {
            if(this.user && this.user.roles){
                let userRoles = this.user.roles
                let portalRoles = [process.env.VUE_APP_SRP_ROLE]
                // js some() fxn returns true if some of the el in arry one exists in array two
                let rolesCheck = userRoles.some((val) => portalRoles.indexOf(val) !== -1);  
                if(rolesCheck !== false){
                    return true
                }
            }
            return false
        }
    },
    created() {
        this.runFetchMarketers()
        this.$emit('update:layout', LayoutUser);
    }
}
</script>